export default {
    quoteDetailLoading: false,
    quoteDetails: {},
    quoteLoading: false,
}